var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResetArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1377 7.81274H8.59375C9.45801 7.81274 10.1562 8.51099 10.1562 9.37524C10.1562 10.2395 9.45801 10.9377 8.59375 10.9377H2.34375C1.47949 10.9377 0.78125 10.2395 0.78125 9.37524V3.12524C0.78125 2.26099 1.47949 1.56274 2.34375 1.56274C3.20801 1.56274 3.90625 2.26099 3.90625 3.12524V5.62524L4.76562 4.76587C9.03809 0.493408 15.9619 0.493408 20.2344 4.76587C24.5068 9.03833 24.5068 15.9622 20.2344 20.2346C15.9619 24.5071 9.03809 24.5071 4.76562 20.2346C4.15527 19.6243 4.15527 18.6331 4.76562 18.0227C5.37598 17.4124 6.36719 17.4124 6.97754 18.0227C10.0293 21.0745 14.9756 21.0745 18.0273 18.0227C21.0791 14.9709 21.0791 10.0247 18.0273 6.9729C14.9756 3.92114 10.0293 3.92114 6.97754 6.9729L6.1377 7.81274Z",
    fill: "url(#paint0_linear_9218_8136)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9218_8136",
    x1: 0.78125,
    y1: 1.56152,
    x2: 22.6453,
    y2: 24.2051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04BEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4481EB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetArrow);
export default __webpack_public_path__ + "static/media/reset_arrow.450b88a4c5a86d05cc8eda802379bacf.svg";
export { ForwardRef as ReactComponent };